import React from 'react';

import { PosOption } from '@/domain/models/Pos';
import { PosItemAndHandlePos } from '@/services/Pos';

import { PosTableInputAndButton } from './PosTableInputAndButton';

interface Props {
  index: number;
  posItem: PosItemAndHandlePos;
  posOption?: PosOption;
  handleInputPosCode: (index: number, newPosCode: string) => void;
  handleInputPromotionOneFreePosCode: (
    index: number,
    newPromotionOneFreePosCode: string
  ) => void;
  handleResetPosCode: (index: number) => void;
  handleResetPromotionOneFreePosCode: (index: number) => void;
}

export const EditableArea: React.VFC<Props> = ({
  index,
  posItem,
  posOption,
  handleInputPosCode,
  handleInputPromotionOneFreePosCode,
  handleResetPromotionOneFreePosCode,
  handleResetPosCode,
}) => {
  const isExistPosPromotion =
    posOption?.type === 'promotion' &&
    posOption.value === 'buy_one_get_one_free';

  const isBlankPosCode = posItem.posCode === '';

  // NOTE ここでpos_item_codeとbuy_one_get_one_free_pos_item_codeがundefinedになることはないのでアーリーリターンで対応。
  if (posItem.pos_item_code === undefined) return <></>;
  if (posItem.buy_one_get_one_free_pos_item_code === undefined) return <></>;

  return (
    <>
      <PosTableInputAndButton
        newValue={posItem.posCode}
        defaultValue={posItem.pos_item_code}
        isBlank={isBlankPosCode}
        index={index}
        handleInputCode={handleInputPosCode}
        handleResetCode={handleResetPosCode}
      />

      {isExistPosPromotion && (
        <PosTableInputAndButton
          newValue={posItem.promotionOneFreePosCode}
          defaultValue={posItem.buy_one_get_one_free_pos_item_code}
          index={index}
          handleInputCode={handleInputPromotionOneFreePosCode}
          handleResetCode={handleResetPromotionOneFreePosCode}
        />
      )}
    </>
  );
};
